<template>
  <b-modal
    id="modal-detail-invoice"
    :title="$t('Detalle de factura')"
    modal-class="dialog-900"
    centered
    no-close-on-backdrop
    @close="close"
  >
    <div class="row" v-if="dataInvoice">
      <div
        v-for="data, index in detailInvoice" :key="index"
        class="col-sm-12 col-md-4 mb-1 container-info"
      >
        <label><b>{{data.title}}</b></label>
        <span v-if="data.useFilter">{{$options.filters.currency(data.text, 0, '$')}}</span>
        <span v-else>{{data.text}}</span>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100">
        <div :id="`button-${index}`" v-for="button, index in buttons" :key="index" class="d-inline-block">
          <b-button
            :variant="button.variant"
            @click="handleButtonClick(button, dataInvoice)"
            :disabled="loading[button.urlKey] || (button.urlKey === 'default' ? !dataInvoice.invoiceUrl : (!button.hasUrl && !(dataInvoice && dataInvoice.invoiceUrl && dataInvoice.invoiceUrl.includes('odoo.com'))))"
            :class="button.class"
          >
            <b-spinner v-show="loading[button.urlKey]" class="mx-1" small/>
            <feather-icon :icon="button.icon" v-show="!loading[button.urlKey]"/> {{button.text}}
            <b-tooltip :target="`button-${index}`" v-if="(button.urlKey === 'default' ? !dataInvoice.invoiceUrl : (!button.hasUrl && !(dataInvoice && dataInvoice.invoiceUrl && dataInvoice.invoiceUrl.includes('odoo.com'))))">
              No hay url disponible
            </b-tooltip>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'modal-detail-invoice',
  props: ['dataInvoice', 'action'],
  data() {
    return {
      detailInvoice: [],
      detailkeys: Object.freeze([
        { title: this.$t('Cliente'), key: 'businessName' },
        { title: this.$t('Identificador Fiscal'), key: 'taxIdentificationNumber' },
        { title: this.$t('Número'), key: 'invoiceNumber' },
        { title: this.$t('Fecha emisión'), key: 'issueDate' },
        { title: this.$t('Fecha vencimiento'), key: 'dueDate' },
        { title: this.$t('Moneda'), key: 'currencyCode' },
        { title: this.$t('Monto neto'), key: 'netAmount', useFilter: true },
        { title: this.$t('Impuestos'), key: 'taxesAmount', useFilter: true },
        { title: this.$t('Total'), key: 'totalAmount', useFilter: true },
        { title: this.$t('Comentario'), key: 'notes' }
      ]),
      buttons: [],
      currentKey: '',
      loading: {
        pdf: false,
        xml: false,
        default: false
      }
    }
  },
  computed: {
    ...mapGetters({
      generalLoading: 'getLoading'
    }),
    isColombiaInvoice() {
      // Check if the invoice is from Colombia based on country code or other identifiers
      return this.dataInvoice && this.dataInvoice.countryCode === 'CO'
    }
  },
  watch: {
    dataInvoice() {
      this.generateElemnts()
    },
    generalLoading: {
      handler() {
        this.loading[this.currentKey] = !!this.generalLoading['getInvoiceBillingDataCompanyById']
      },
      deep: true
    }
  },
  mounted() {
    this.generateElemnts()
  },
  methods: {
    generateElemnts() {
      this.detailInvoice = this.detailkeys.map(e => {
        e.text = this.dataInvoice[e.key] || '--'
        return e
      })

      // For Colombia, all buttons should be enabled regardless of URL availability
      const isFromColombia = this.isColombiaInvoice
      this.buttons = [
        { variant: 'success', icon: 'FileTextIcon', urlKey: 'pdf', text: 'PDF', hasUrl: isFromColombia ? true : this.dataInvoice.hasPdfurl},
        { variant: 'success', icon: 'FileIcon', urlKey: 'xml', text: 'XML', class: 'mx-1', hasUrl: isFromColombia ? true : this.dataInvoice.hasXmlurl},
        { variant: 'primary', icon: 'LinkIcon', urlKey: 'default', text: 'Documento', hasUrl: true } // Documento debe cambiar a Bemmbo cuando se migre
      ]
    },
    handleButtonClick(button, dataInvoice) {
      this.currentKey = button.urlKey
      if (button.urlKey === 'default' && dataInvoice.invoiceUrl) {
        this.openInvoiceUrl(dataInvoice.invoiceUrl)
      } else {
        this.action(dataInvoice, button.urlKey)
      }
    },
    close() {
      this.$bvModal.hide('modal-detail-invoice')
    },
    openInvoiceUrl(url) {
      if (url) {
        window.open(url, '_blank')
        this.loading[this.currentKey] = false
      }
    }
  }
}
</script>
